module.exports = __webpack_public_path__ + "static/media/woman.6e1dfd0d.jpg";